// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import wx from 'weixin-jsapi'
import 'mint-ui/lib/style.css'

import {Loadmore,DatetimePicker} from 'mint-ui'
Vue.component(Loadmore.name, Loadmore);
Vue.component(DatetimePicker.name, DatetimePicker);

Vue.ne
import global_ from './components/Global'
Vue.prototype.nyy = global_
Vue.config.productionTip = false
import $ from 'jquery';
window.jQuery = $;
// window.$ = $;

// import 'signalr'

import eventBus from './components/eventBus.js'
Vue.prototype.eventBus = eventBus//挂载到Vue实例上面

import NyyDatePicker from "./components/datesSelect";
Vue.component("NyyDatePicker", NyyDatePicker);

import loading from "./components/common/loading";
Vue.component("loading", loading);
Vue.prototype.bus = new Vue;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js